"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.semanticPositiveBackground = exports.navigationItemHover = exports.navigationItemActive = exports.backgroundAccentCard = exports.actionableSecondary = exports.actionablePrimary = exports.actionableHover = void 0;
var actionablePrimary = "#1F63D2";
exports.actionablePrimary = actionablePrimary;
var actionableHover = "#004D99";
exports.actionableHover = actionableHover;
var actionableSecondary = "#0E680E";
exports.actionableSecondary = actionableSecondary;
var navigationItemActive = "#1F63D2";
exports.navigationItemActive = navigationItemActive;
var navigationItemHover = "#0E680E";
exports.navigationItemHover = navigationItemHover;
var semanticPositiveBackground = "#ffffff";
exports.semanticPositiveBackground = semanticPositiveBackground;
var backgroundAccentCard = "#ffffff";
exports.backgroundAccentCard = backgroundAccentCard;
//# sourceMappingURL=universal.js.map